import { render, staticRenderFns } from "./KitchenOrders.vue?vue&type=template&id=176380f9&"
import script from "./KitchenOrders.vue?vue&type=script&lang=js&"
export * from "./KitchenOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports